import {
    getSiteNavigationFiltersRepo,getSiteNavigationRepo, getSiteNavigationItemsRepo, postSiteNavigationItemsRepo, putSiteNavigationItemsRepo, deleteSiteNavigationItemsRepo,
    getSiteNavigationEditRepo,
} from "../repositories/headerFooter/headerFooter.js"
import { createSlice } from "@reduxjs/toolkit";

const headerFooterSlice = createSlice({
    name: "headerFooterReducer",
    initialState: {

        siteNavigationFiltersLoading: false,
        siteNavigationFiltersData: null,
        siteNavigationFiltersError: null,

        siteNavigationDataLoading: false,
        siteNavigationData: null,
        siteNavigationDataError: null,

        siteNavigationEditLoading: false,
        siteNavigationEditData: null,
        siteNavigationEditError: null,

        siteNavigationItemsDataLoading: false,
        siteNavigationItemsData: null,
        siteNavigationItemsDataError: null,

        postSiteNavigationItemsDataLoading: false,
        postSiteNavigationItemsData: null,
        postSiteNavigationItemsDataError: null,

        putSiteNavigationItemsDataLoading: false,
        putSiteNavigationItemsData: null,
        putSiteNavigationItemsDataError: null,

        deleteSiteNavigationItemsDataLoading: false,
        deleteSiteNavigationItemsData: null,
        deleteSiteNavigationItemsDataError: null,

        getLevel1LoadingData:false,
        getLevel1Data:null,
        getLevel1ErrorData:null,

        getLevel2LoadingData:false,
        getLevel2Data:null,
        getLevel2ErrorData:null,

        getLevel3LoadingData:false,
        getLevel3Data:null,
        getLevel3ErrorData:null,

        message:null,

    },
    reducers: {

        getSiteNavigationFiltersLoading(state, action) {
            return {
                ...state,
                siteNavigationFiltersLoading: true,
            };
        },
        getSiteNavigationFiltersSuccess(state, action) {
            return {
                ...state,
                siteNavigationFiltersLoading: false,
                siteNavigationFiltersData: action.payload,
            };
        },
        getSiteNavigationFiltersFailure(state, action) {
            return {
                ...state,
                siteNavigationFiltersLoading: false,
                siteNavigationFiltersError: action.payload,
            };
        },

        clearSiteNavigationFiltersReponse(state, action) {
            return {
                ...state,
                siteNavigationFiltersData: null,
                siteNavigationFiltersError: null,
            };
        },

        getSiteNavigationLoading(state, action) {
            return {
                ...state,
                siteNavigationDataLoading: true,
            };
        },
        getSiteNavigationSuccess(state, action) {
            return {
                ...state,
                siteNavigationDataLoading: false,
                siteNavigationData: action.payload,
            };
        },
        getSiteNavigationFailure(state, action) {
            return {
                ...state,
                siteNavigationDataLoading: false,
                siteNavigationDataError: action.payload,
            };
        },

        clearSiteNavigationReponse(state, action) {
            return {
                ...state,
                siteNavigationData: null,
                siteNavigationDataError: null,
            };
        },

        getSiteNavigationEditLoading(state, action) {
            return {
                ...state,
                siteNavigationEditLoading: true,
            };
        },
        getSiteNavigationEditSuccess(state, action) {
            return {
                ...state,
                siteNavigationEditLoading: false,
                siteNavigationEditData: action.payload,
            };
        },
        getSiteNavigationEditFailure(state, action) {
            return {
                ...state,
                siteNavigationEditLoading: false,
                siteNavigationEditError: action.payload,
            };
        },

        getSiteNavigationItemsLoading(state, action) {
            return {
                ...state,
                siteNavigationItemsDataLoading: true,
            };
        },
        getSiteNavigationItemsSuccess(state, action) {
            return {
                ...state,
                siteNavigationItemsDataLoading: false,
                siteNavigationItemsData: action.payload,
            };
        },
        getSiteNavigationItemsFailure(state, action) {
            return {
                ...state,
                siteNavigationItemsDataLoading: false,
                siteNavigationItemsDataError: action.payload,
            };
        },

        clearSiteNavigationItemsReponse(state, action) {
            return {
                ...state,
                siteNavigationItemsData: null,
                siteNavigationItemsDataError: null,
            };
        },

        postSiteNavigationItemsLoading(state, action) {
            return {
                ...state,
                postSiteNavigationItemsDataLoading: true,
            };
        },
        postSiteNavigationItemsSuccess(state, action) {
            return {
                ...state,
                postSiteNavigationItemsDataLoading: false,
                postSiteNavigationItemsData: action.payload,
                message:"Data Added Successfully",
            };
        },
        postSiteNavigationItemsFailure(state, action) {
            return {
                ...state,
                postSiteNavigationItemsDataLoading: false,
                postSiteNavigationItemsDataError: action.payload,
                message:action.payload,
            };
        },

        clearPostSiteNavigationItemsReponse(state, action) {
            return {
                ...state,
                postSiteNavigationItemsData: null,
                postSiteNavigationItemsDataError: null,
            };
        },

        putSiteNavigationItemsLoading(state, action) {
            return {
                ...state,
                putSiteNavigationItemsDataLoading: true,
            };
        },
        putSiteNavigationItemsSuccess(state, action) {
            return {
                ...state,
                putSiteNavigationItemsDataLoading: false,
                putSiteNavigationItemsData: action.payload,
            };
        },
        putSiteNavigationItemsFailure(state, action) {
            return {
                ...state,
                putSiteNavigationItemsDataLoading: false,
                putSiteNavigationItemsDataError: action.payload,
            };
        },

        clearPutSiteNavigationItemsReponse(state, action) {
            return {
                ...state,
                putSiteNavigationItemsData: null,
                putSiteNavigationItemsDataError: null,
            };
        },

        deleteSiteNavigationItemsDataLoading(state, action) {
            return {
                ...state,
                deleteSiteNavigationItemsDataLoading: true,
                message: null
            };
        },
        deleteSiteNavigationItemsDataSuccess(state, action) {
            return {
                ...state,
                deleteSiteNavigationItemsDataLoading: false,
                deleteSiteNavigationItemsData: action.payload,
                message:"Deleted Successfully",
            };
        },
        deleteSiteNavigationItemsDataFailure(state, action) {
            return {
                ...state,
                deleteSiteNavigationItemsDataLoading: false,
                deleteSiteNavigationItemsDataError: action.payload,
                message:"Failure in Deleting Data"
            };
        },
        getLevel1Loading(state, action) {
            return {
                ...state,
                getLevel1LoadingData: true,
            };
        },
        getLevel1Success(state, action) {
            return {
                ...state,
                getLevel1LoadingData: false,
                getLevel1Data: action.payload,
            };
        },
        getLevel1Failure(state, action) {
            return {
                ...state,
                getLevel1LoadingData: false,
                getLevel1ErrorData: action.payload,
            };
        },
        getLevel2Loading(state, action) {
            return {
                ...state,
                getLevel2LoadingData: true,
            };
        },
        getLevel2Success(state, action) {
            return {
                ...state,
                getLevel2LoadingData: false,
                getLevel2Data: action.payload,
            };
        },
        getLevel2Failure(state, action) {
            return {
                ...state,
                getLevel2LoadingData: false,
                getLevel2ErrorData: action.payload,
            };
        },
        getLevel3Loading(state, action) {
            return {
                ...state,
                getLevel3LoadingData: true,
            };
        },
        getLevel3Success(state, action) {
            return {
                ...state,
                getLevel3LoadingData: false,
                getLevel3Data: action.payload,
            };
        },
        getLevel3Failure(state, action) {
            return {
                ...state,
                getLevel3LoadingData: false,
                getLevel3ErrorData: action.payload,
            };
        },
        clearMessage(state,action){
            return{
                ...state,
                message:null,
                postSiteNavigationItemsDataError:null,
            }
        },
        clearAllReponses(state, action) {
            return {
                ...state,
        siteNavigationFiltersData: null,
        siteNavigationFiltersError: null,

        siteNavigationData: null,
        siteNavigationDataError: null,

        siteNavigationEditData: null,
        siteNavigationEditError: null,

        siteNavigationItemsData: null,
        siteNavigationItemsDataError: null,

        postSiteNavigationItemsData: null,
        postSiteNavigationItemsDataError: null,

        putSiteNavigationItemsData: null,
        putSiteNavigationItemsDataError: null,

        deleteSiteNavigationItemsData: null,
        deleteSiteNavigationItemsDataError: null,

        getLevel1Data:null,
        getLevel1ErrorData:null,

        getLevel2Data:null,
        getLevel2ErrorData:null,

        getLevel3Data:null,
        getLevel3ErrorData:null,

            };
        },
    },
});

export const {
    getSiteNavigationFiltersLoading,
    getSiteNavigationFiltersSuccess,
    getSiteNavigationFiltersFailure,
    clearSiteNavigationFiltersReponse,

    getSiteNavigationLoading,
    getSiteNavigationSuccess,
    getSiteNavigationFailure,
    clearSiteNavigationReponse,

    getSiteNavigationItemsLoading,
    getSiteNavigationItemsSuccess,
    getSiteNavigationItemsFailure,
    clearSiteNavigationItemsReponse,

    postSiteNavigationItemsLoading,
    postSiteNavigationItemsSuccess,
    postSiteNavigationItemsFailure,
    clearPostSiteNavigationItemsReponse,

    putSiteNavigationItemsLoading,
    putSiteNavigationItemsSuccess,
    putSiteNavigationItemsFailure,
    clearPutSiteNavigationItemsReponse,

    deleteSiteNavigationItemsDataLoading,
    deleteSiteNavigationItemsDataSuccess,
    deleteSiteNavigationItemsDataFailure,

    getSiteNavigationEditLoading,
    getSiteNavigationEditSuccess,
    getSiteNavigationEditFailure,

    getLevel1Loading,
    getLevel1Success,
    getLevel1Failure,

    getLevel2Loading,
    getLevel2Success,
    getLevel2Failure,

    getLevel3Loading,
    getLevel3Success,
    getLevel3Failure,

    clearMessage,
    clearAllReponses,
} = headerFooterSlice.actions;

export const getSiteNavigationFilters = (params) => {
    return async (dispatch) => {
        dispatch(getSiteNavigationFiltersLoading());
        await getSiteNavigationFiltersRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getSiteNavigationFiltersSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getSiteNavigationFiltersFailure(error.message));
                }
            });
    };
};

export const getSiteNavigation = (params) => {
    return async (dispatch) => {
        dispatch(getSiteNavigationLoading());
        await getSiteNavigationRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getSiteNavigationSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getSiteNavigationFailure(error.message));
                }
            });
    };
};

export const getSiteNavigationEdit = (id, data) => {
    return async (dispatch) => {
        await getSiteNavigationEditRepo(id, data)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getSiteNavigationEditSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getSiteNavigationEditFailure(error.message));
                }
            });
    };
};

export const getSiteNavigationItems = (params) => {
    return async (dispatch) => {
        dispatch(getSiteNavigationItemsLoading());
        await getSiteNavigationItemsRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getSiteNavigationItemsSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getSiteNavigationItemsFailure(error.message));
                }
            });
    };
};

export const postSiteNavigationItems = (params) => {
    return async (dispatch) => {
        dispatch(postSiteNavigationItemsLoading());
      try {
        const response = await postSiteNavigationItemsRepo(params);
  
        if (response.status >= 200 && response.status <= 300) {
          dispatch(postSiteNavigationItemsSuccess(response?.data));
        }
      } catch (error) {
        if (error && error.response) {
          const contentType = error.response.headers["content-type"];
  
          let normalizedError;
  
          if (contentType && contentType.includes("application/json")) {
            //  backend sent proper JSON (e.g. validation errors)
            normalizedError = error.response.data;
          } else {
            //  backend sent HTML / plain text (likely 500 or server crash)
            normalizedError = {
              json_error: ["Something went wrong. Please try again later."],
            };
          }
  
          dispatch(postSiteNavigationItemsFailure(normalizedError));
        } else {
          // No response at all (network error, timeout, CORS issue, etc.)
          dispatch(
            postSiteNavigationItemsFailure({
              network_error: ["Network error. Please check your connection."],
            })
          );
        }
      }
    };
  };
  

export const putSiteNavigationItems = (id, data) => {
    return async (dispatch) => {
        await putSiteNavigationItemsRepo(id, data)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(putSiteNavigationItemsSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putSiteNavigationItemsFailure(error.message));
                }
            });
    };
};

export const deleteSiteNavigationItems = (params) => {
    return async (dispatch) => {
        await deleteSiteNavigationItemsRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                   
                    dispatch(deleteSiteNavigationItemsDataSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(deleteSiteNavigationItemsDataFailure(error.response?.data));
                }
            });
    };
};
// action for Dropdown data for level 1
export const getLevel1DropdownData = (params) => {
    return async (dispatch) => {
        dispatch(getLevel1Loading());
        await getSiteNavigationItemsRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getLevel1Success(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getLevel1Failure(error.message));
                }
            });
    };
};

// action for Dropdown data for level 2
export const getLevel2DropdownData = (params) => {
    return async (dispatch) => {
        dispatch(getLevel2Loading());
        await getSiteNavigationItemsRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getLevel2Success(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getLevel2Failure(error.message));
                }
            });
    };
};

// action for Dropdown data for level 3
export const getLevel3DropdownData = (params) => {
    return async (dispatch) => {
        dispatch(getLevel3Loading());
        await getSiteNavigationItemsRepo(params)
            .then((response) => {
                if (response.status >= 200 && response.status <= 300) {
                    dispatch(getLevel3Success(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getLevel3Failure(error.message));
                }
            });
    };
};

export default headerFooterSlice.reducer;